define('viewmodels/menu',[
    'underscore',
    'knockout',
    'jquery',
    'common/clientSniffer'
], function (_, ko, $, client) {
    /* eslint-disable max-statements*/
    function MenuViewModel (
        session,
        LogoutCommand,
        router,
        getField,
        getGlobalAssets,
        olarkService,
        currentCountry
    ) {
        var self = this;

        function isInMarket () {
            return currentCountry.property('code')() === getField('show_live_help_in_menu_by_market_code')();
        }
        self.session = session;
        self.router = router;
        self.player = session.getAssociatedPlayer;
        self.olarkService = olarkService;
        self.help = olarkService.help;
        self.isTablet = ko.observable(client.device.type === 'tablet' || !client.device.type);

        $(window).resize(function () {
            if (client.device.type !== 'tablet') {
                self.isTablet(false);
            }
        });

        self.formattedBalance = ko.deferredComputed(function () {
            return self.player().wallet.balance();
        }).extend({
            cash: true
        }).formattedCash;

        self.logoutCommand = new LogoutCommand();

        self.isSelected = function (ids) {
            return ko.deferredComputed(function () {
                var activeInstruction = self.router.activeInstruction();

                //Guard
                if (!activeInstruction || (activeInstruction && !activeInstruction.config.id)) {
                    return;
                }

                if (_.isArray(ids)) {
                    return _.includes(ids, activeInstruction.config.id);
                } else {
                    return activeInstruction.config.id.indexOf(ids) > -1;
                }
            });
        };

        self.logInLinkText = getField('log_in_link_text');
        self.signUpLinkText = getField('sign_up_link_text');
        self.gameBrowserLinkText = getField('game_browser_link_text');
        self.logOutLinkText = getField('log_out_link_text');
        self.faqLinkText = getField('faq_link_text');
        self.playOkayLinkText = getField('play_okay_link_text');
        self.contactUsLinkText = getField('contact_us_link_text');
        self.aboutUsLinkText = getField('about_us_link_text');
        self.showLiveHelpInMenu = ko.pureComputed(function () {
            return ko.unwrap(getField('show_live_help_in_menu')) && isInMarket();
        });
        self.helpText = getField('help_text');
        self.settingsLinkText = getField('settings_link_text');
        self.blogMenuText = getField('blog_menu_text');
        self.blogMenuUrl = getField('blog_menu_url');
        self.logInIcon = getField('log_in_icon');
        self.signUpIcon = getField('sign_up_icon');
        self.gameBrowserIcon = getField('game_browser_icon');
        self.cashIcon = getField('cash_icon');
        self.casumoLogo = getGlobalAssets('casumo_logo');
    }

    MenuViewModel.prototype.logout = function () {
        this.logoutCommand.dispatch(function () {
            window.location = '/';
        });
    };

    return MenuViewModel;
});

